<template>
    <a href="#" class="hover-underline" @click.prevent="open = true">{{ company.name }}</a>
    <Teleport to="body">
        <div class="st-modal" :class="{ 'st-modal--active': open }">
            <div class="st-modal__content">
                <div class="st-modal__header">
                    <div class="hero__header">{{ company.name }}</div>
                </div>
                <div class="st-modal__text">
                    <div v-if="error" class="form__error">{{ error }}</div>

                    <template v-if="confirming">
                        <p class="company-modal__confirm-message">Er du sikker på at du vil fjerne koblingen til {{ company.name }}?</p>
                        <div class="mypage__editbar">
                            <button type="button" class="action" :disabled="leaving" @click="leaveCompany">{{ leaving ? 'Fjerner...' : 'Bekreft' }}</button>
                            <button type="button" class="action action--hollow" :disabled="leaving" @click="confirming = false">Avbryt</button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="mypage__editbar">
                            <button type="button" class="action action--hollow" @click="confirming = true">Fjern kobling til bedrift</button>
                            <button type="button" class="action" @click="close">Lukk</button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    company: { type: Object, required: true },
    csrfToken: { type: String, required: true },
});

const emit = defineEmits(['left']);

const open = ref(false);
const confirming = ref(false);
const leaving = ref(false);
const error = ref(null);

function close() {
    open.value = false;
    confirming.value = false;
    error.value = null;
}

async function leaveCompany() {
    error.value = null;
    leaving.value = true;

    try {
        const response = await fetch(`/xhr/frontend/companies/${props.company.id}/leave`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': props.csrfToken,
            },
        });

        if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            error.value = data.message || 'Noe gikk galt, prøv igjen.';
            confirming.value = false;
            return;
        }

        emit('left', props.company.id);
        open.value = false;
    } catch (e) {
        error.value = 'Noe gikk galt, prøv igjen.';
        confirming.value = false;
    } finally {
        leaving.value = false;
    }
}
</script>

<style scoped>
.company-modal__confirm-message {
    text-align: center;
}
</style>
